<template>
  <div class="page-container">
    <div class="main">
      <!-- <div class="top">
        <h3 class="intro-txt">{{ $route.name }}</h3>
      </div> -->
      <el-row type="flex" justify="end" align="middle">
        <el-col :span="24" style="text-align: left;">
          <el-button
            type="primary"
            size="small"
            :disabled="multipleSelection.length === 0"
            style="margin-left: 30px;margin-top: 10px;"
            @click="handleBatchSend"
            >{{ $t('text.batchSendMessage') }}</el-button
          >
        </el-col>
      </el-row>

      <el-table
        :data="tableData"
        style="width: 100%; margin: 20px 0 0 0"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="80" align="center">
        </el-table-column>
        
        <el-table-column
            prop="appId"
            width="160px"
            :label="$t('text.appId')"
            align="center"
          >
          </el-table-column>
          <el-table-column
            width="180"
            prop="merchantName"
            :label="$t('text.merchantName')"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="loginName"
            width="180px"
            :label="$t('text.loginName')"
            align="center"
          >
          </el-table-column>

        <el-table-column
          prop="groupName"
          :label="$t('text.tgGroupName')"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="groupId"
          :label="$t('text.tgGroupId')"
          align="center"
        ></el-table-column>

        <el-table-column :label="$t('text.actions')" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="success"
              size="small"
              @click="handleSend(row.groupId)"
              >{{ $t('text.sendMessage') }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <SendMessage :show.sync="showDialog" :id="groupId"></SendMessage>
  </div>
</template>
<script>

import SendMessage from './components/SendMessage'
export default {
  components: { SendMessage: SendMessage },
  data() {
    return {
      tableData: [],
      multipleSelection: [],
      strMultipleSelection: [],
      showDialog: false,
      groupId: [],
    }
  },
  created() {
    this.axios.get('/notice/getTgGroups', { params: {} }).then(res => {
      if (res.code === 200) {
        this.tableData = res.data
      }
    })
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.strMultipleSelection = this.multipleSelection.map(
        ({ groupId }) => groupId
      )
    },
    handleSend(id) {
      this.groupId = [id]
      this.showDialog = true
    },
    handleBatchSend() {
      this.groupId = this.strMultipleSelection
      this.showDialog = true
    },
  },
}
</script>

<style>
.el-table th, .el-table td {
  padding: 1px;
  }
  .el-table .el-table__cell {
    padding: 1px;
  }
</style>